import { Link } from 'react-router-dom';

import Icon from '../../../assets/icons/Icon';

const NavigationBottom = (props) => {
    const { prevLink, prevTitle, nextLink, nextTitle } = props;

    return (
        <div className="documentation__nav-bottom">
            <div className="documentation__nav-bottom-left">
                {prevLink && (
                    <Link className="faq-nav-link" to={prevLink}>
                        <Icon icon="ChevronLeft" />
                        <p className="font-weight-bold">{prevTitle}</p>
                    </Link>
                )}
            </div>
            <div className="documentation__nav-bottom-right">
                {nextLink && (
                    <Link className="faq-nav-link" to={nextLink} data-cy="faq__bottomNav--next">
                        <p className="font-weight-bold">{nextTitle}</p>
                        <Icon icon="ChevronRight" />
                    </Link>
                )}
            </div>
        </div>
    );
};

export default NavigationBottom;
